import { useState } from "react";
import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { Pill } from "../components/jamora-admin/AdminBits";
import { PageHeader } from "../components/jamora-admin/AdminBits";
import { AdminTable, FilterTabs, ListFrame, MoreFooter, SearchBox } from "../components/jamora-admin/ListBits";
import useAdminList from "../hooks/useAdminList";
import { ROLE_LABELS, canViewPharmacyData, pharmacyPath } from "../lib/jamoraAdmin";
import { formatDateTime } from "../lib/tickets";
import { useAuth } from "../contexts/AuthContext";

const STATE_TABS = [["", "Tous"], ["true", "Actifs"], ["false", "Désactivés"]];
const ROLE_TABS = [["", "Tous les rôles"], ...Object.entries(ROLE_LABELS)];

// The accounts of the whole platform, including the Jamora team's own (no pharmacy). Never a password, a PIN or a token.
export default function JamoraAdminUsers() {
  const { user } = useAuth();
  const [active, setActive] = useState("");
  const [role, setRole] = useState("");
  const [search, setSearch] = useState("");
  const list = useAdminList("/users", { active, role, search });
  const canOpenFile = canViewPharmacyData(user);
  const columns = [
    { id: "name", label: "Nom", primary: true, cell: (u) => <span>{u.name || u.username}<span className="block text-xs text-slate-500">{u.username}</span></span> },
    { id: "pharmacy", label: "Pharmacie", cell: (u) => (!u.pharmacy ? <Pill tone="violet">Équipe Jamora</Pill> : canOpenFile ? <Link className="text-jamora hover:underline" to={`${pharmacyPath(u.pharmacy.schema)}?tab=comptes`}>{u.pharmacy.name}</Link> : u.pharmacy.name) },
    { id: "role", label: "Rôle", cell: (u) => ROLE_LABELS[u.role] || u.role },
    { id: "state", label: "État", cell: (u) => <Pill tone={u.active ? "emerald" : "red"}>{u.active ? "Actif" : "Désactivé"}</Pill> },
    { id: "email", label: "E-mail", hide: "lg", cell: (u) => u.email || "—" },
    { id: "login", label: "Dernière connexion", hide: "lg", cell: (u) => (u.last_login ? formatDateTime(u.last_login) : "Jamais") },
  ];
  return (
    <div className="space-y-4" data-testid="admin-users">
      <PageHeader title="Comptes" description="Tous les comptes de la plateforme : pharmacies et équipe Jamora. Lecture seule." />
      <FilterTabs label="État du compte" tabs={STATE_TABS} value={active} onChange={setActive} testid="platform-users-state" />
      <div className="flex items-center gap-2 flex-wrap">
        <select aria-label="Rôle" value={role} onChange={(e) => setRole(e.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid="platform-users-role">
          {ROLE_TABS.map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </select>
        <SearchBox value={search} onChange={setSearch} placeholder="Identifiant, nom ou e-mail…" testid="platform-users-search" />
      </div>
      <ListFrame list={list} empty={{ icon: Users, title: "Aucun compte", hint: active || role || search ? "Essayez un autre filtre." : "Aucun compte n'est enregistré.", testid: "platform-users-empty" }}>
        <AdminTable columns={columns} rows={list.items} rowKey={(u) => u.id} testid="platform-users-table" />
        <MoreFooter list={list} noun="compte(s)" testid="platform-users" />
      </ListFrame>
    </div>
  );
}
